'use strict'

import ApiClient from './ApiClient'

export default class PasswordPolicyRepository {
  /**
   * パスワード ポリシー取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/passwordpolicy`)
  }

  /**
   * パスワードポリシー更新
   * @param params
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/passwordpolicy`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/PasswordPolicyRepository.js